import generalUpload from "../_section/upload.class";

export class userResidencePermitUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
            optional: true,
        },
        {
            name: 'expiryDate',
            label: 'Expiry Date',
            type: 'date',
        },
        {
            name: 'stampNumber',
            label: 'Stamp Number',
            type: 'int',
        }]
}

export class adminResidencePermitUpload extends userResidencePermitUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.expiryDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.expiryDate,
            })
        }

    }
}
